import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LessonHighlightState {
  lessonHighlight: any,
  _hasHydrated: boolean | null;
  setLessonHighlight: (lessonHighlight: any) => void;
  setHasHydrated: (hydrate: boolean) => void;
  resetLessonHighlight: () => void;
}

export const useLessonHighlightStore = create<LessonHighlightState>()(
  persist(
    (set) => ({
      _hasHydrated: false,
      lessonHighlight: null,
      setLessonHighlight: (lessonHighlight) => {
        if (lessonHighlight && lessonHighlight.length && lessonHighlight[0]) {
          const lesson = lessonHighlight[0];
          const { area, subarea } = lesson.ancestors;
          const subject = lesson.subjects && lesson.subjects[0] ? lesson.subjects[0] : null;
          
          if (subject) {
            lesson.link = `/disciplinas/${area.slug}/modulo/${subarea.slug}/assunto/${subject.slug}/videoaula/${lesson.slug}`;
            set({ lessonHighlight: lesson });
          }
        }
      },
      setHasHydrated: (hydrate: boolean) => set({ _hasHydrated: hydrate }),
      resetLessonHighlight: () => set({ _hasHydrated: false, lessonHighlight: null })
    }),
    {
      name: 'lesson-highlight-store',
      onRehydrateStorage: () => (state) => {
        state && state.setHasHydrated(true);
      },
    },
  ),
);
